const { MODE } = import.meta.env

export const BASE_URL =
  MODE === 'development' ? 'https://wgs-msk.soilbox.app' : ''
